// extracted by mini-css-extract-plugin
export default {"root":"order-book-table-row_root__yBmMD","asc":"order-book-table-row_asc__EN+4+","bid":"order-book-table-row_bid__qefPj"};